import {
  platformCoordApiConfig,
  type PlatformCoordRouteTypeMap,
} from 'platform-coord-functions/client'
import { backendClient } from '@/utils/backendClient'

export const platformCoordApi = backendClient<PlatformCoordRouteTypeMap>(platformCoordApiConfig)
